import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import PhoneImg from "../../assets/telephone.png";
import { useState } from "react";
import axios from "axios";
import Header from "../Header.tsx";
import Footer from "../Footer.tsx";
import Userimg from "../../assets/user.png";
import "../../styles/layouts.scss";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

//images
const subscribe = VISUALIZE__URL + "freetrail_bg.webp";
const EmailImg = VISUALIZE__URL + "email.webp";

interface FormData {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  message?: string;
}

interface FormErrors {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  message?: string;
}
const PreloginContact = () => {
  const { t } = useTranslation();
  // const [analyticStarted, setAnalyticStarted] = useState(false)

  const [formData, setFormData] = useState<FormData>({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({});

  const validateField = (name: string, value: string) => {
    let error = "";

    switch (name) {
      case "first_name":
        if (!value) error = "Please enter first name.";
        break;
      case "last_name":
        if (!value) error = "Please enter last name.";
        break;
      case "email":
        if (!validateEmail(value))
          error = "Please enter a valid email address.";
        break;
      case "phone_number":
        if (!value) error = "Please enter contact phone number.";
        break;
      default:
        break;
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const validateForm = () => {
    const errors: FormErrors = {};

    if (!formData.first_name.trim()) {
      errors.first_name = "Please enter first name.";
    }
    if (!formData.last_name.trim()) {
      errors.last_name = "Please enter last name.";
    }
    if (!formData.phone_number.trim()) {
      errors.phone_number = "Please enter contact phone number.";
    }
    if (!validateEmail(formData.email)) {
      errors.email = "Please enter a valid email address.";
    }

    // Set the errors state
    setFormErrors(errors);

    // Return false if there are any errors, true otherwise
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if (!analyticStarted) {
    //   setAnalyticStarted(true);
    //   handleFormStart();
    // }
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    validateField(name, value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    window.gtag("event", "form_submit", {
      page_path: window.location.pathname,
      form_type: "contact",
      username: formData.first_name,
      user_phone: formData.phone_number,
      user_message: formData.message,
      environment: process.env.NODE_ENV,
    })
    if (!validateForm()) {
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}contact_us/v1/form_submit`, formData);
      setTimeout(() => {
        toast.success(t("form_submitted_successfully"));
        handleFormSubmit(true)
      });
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: "",
      });
    } catch (error) {
      handleFormSubmit(false)
      console.log(error);
    }
  };

  // const handleFormStart = () => {
  //   if (typeof window.gtag === "function") {
  //     window.gtag("event", "form_start", {
  //       page_path: window.location.pathname,
  //       form_type: "contact",
  //       environment: process.env.NODE_ENV,
  //     })
  //   }
  // }

  const handleFormSubmit = (isSuccess: boolean) => {
    if (typeof window.gtag === "function") {
      window.gtag("event", isSuccess ? "form_sucess" : "form_error", {
        page_path: window.location.pathname,
        form_type: "contact",
        environment: process.env.NODE_ENV,
      })
    }
  }

  const officeLocations = [
    {
      title: t(""),
      email: "contact@clinicalvisuals.com",
    },
  ];
  return (
    <>
      <Header />

      <Box
        className="contact_main"
        sx={{
          backgroundImage: `url(${subscribe})`,
          zIndex: -1,
          "&::before": {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay with 50% opacity
            zIndex: -1, // Ensures it stays above the background but below the content
          },
        }}
      >
        <Box
          sx={{ textAlign: "center", maxWidth: "1200px", mx: "auto", px: 3 }}
        >
          <Typography
            className="ctitle"
            variant="h3"
            component="h1"
            sx={{ fontWeight: "bold", mb: 1, textTransform: "uppercase" }}
          >
            {t("contact_us")}
            {/* CONTACT US */}
          </Typography>
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        className="contact_form"
        sx={{ maxWidth: "1200px", mx: "auto", py: 6, px: 3 }}
      >
        {/* Contact Info Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            backgroundColor: "#1976d2",
            borderRadius: 5,
            color: "white",
            mb: 6,
            m: { xs: 1 },
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              flex: 1,
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                left: "100%",
                top: "20%",
                transform: "translateX(-50%)",
                borderRadius: "0px",
                display: { xs: "none", md: "flex" },
              },
            }}
          >
            <Typography
              variant="h4"
              sx={{ mt: { xs: 0, sm: 0, md: 2 }, mb: 3, fontWeight: "bold" }}
            >
              {t("contact_details")}
            </Typography>

            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ textAlign: "center" }}
            >
              {officeLocations.map((location, index) => (
                <Grid
                  item
                  xs={12}
                  md={3}
                  key={index}
                  sx={{
                    borderRight: {
                      xs: "none",
                      md:
                        index !== officeLocations.length - 1
                          ? "1px solid rgba(255,255,255,0.2)"
                          : "none",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      // gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: { xs: "20px", md: "20px" },
                      }}
                    >
                      {location.title}
                    </Typography>

                    <Typography
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "18px", md: "18px" },
                      }}
                    >
                      <Box
                        component="a"
                        href={`mailto:${location.email}`}
                        sx={{
                          color: "inherit",
                          textDecoration: "none",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {location.email}
                      </Box>
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        {/* Contact Form */}
        <Box sx={{ mt: { xs: 0, sm: 6 } }}>
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid className="contact_form" container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  placeholder={t("enter_your_first_name")}
                  variant="outlined"
                  fullWidth
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  error={!!formErrors.first_name}
                  helperText={formErrors.first_name}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "20px",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Box
                        component="img"
                        src={Userimg}
                        alt="User"
                        sx={{
                          width: 24, // Adjust the size as needed
                          height: 24,
                          mr: 1,
                        }}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  placeholder={t("enter_your_last_name")}
                  variant="outlined"
                  fullWidth
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
                  error={!!formErrors.last_name}
                  helperText={formErrors.last_name}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "20px",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Box
                        component="img"
                        src={Userimg}
                        alt="User"
                        sx={{
                          width: 24, // Adjust the size as needed
                          height: 24,
                          mr: 1,
                        }}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder={t("enter_your_email_address")}
                  variant="outlined"
                  type="email"
                  fullWidth
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "20px",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Box
                        component="img"
                        src={EmailImg}
                        alt="email"
                        sx={{
                          width: 24, // Adjust the size as needed
                          height: 24,
                          mr: 1,
                        }}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder={t("contact_number")}
                  variant="outlined"
                  type="tel"
                  fullWidth
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                  error={!!formErrors.phone_number}
                  helperText={formErrors.phone_number}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "20px",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Box
                        component="img"
                        src={PhoneImg}
                        alt="phone"
                        sx={{
                          width: 24, // Adjust the size as needed
                          height: 24,
                          mr: 1,
                        }}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder={t("message")}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "20px",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{}}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: "#1976d2",
                    py: 1.5,
                    px: 4,
                    textTransform: "none",
                    fontWeight: "bold",
                    borderRadius: "20px",
                  }}
                >
                  {t("send_message")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
      <Footer />
    </>
  );
};
export default PreloginContact;
